import { Button, CircularProgress, TextField } from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import React, { useContext } from "react";
import * as Yup from "yup";
import useApi from "../../../../../../../hooks/api";
import useAuth from "../../../../../../../hooks/auth";
import { DateTimeField } from "../../../../../../ui/form_fields/epoch";
import { CrmContext } from "../../../../context";

const validationSchema = Yup.object({
  title: Yup.string().required("Título é obrigatório"),
  start_date: Yup.date().nullable().typeError("Data inválida"),
  due_date: Yup.date().typeError("Defina uma data limite"),
});

const currentDate = new Date();

export default () => {
  const context = useContext(CrmContext);
  const { post } = useApi();
  const { user } = useAuth();

  const initialValues = {
    assigned_by: user.id,
    title: "",
    description: "",
    start_date: currentDate,
    due_date: null,
  };

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    try {
      const { data } = await post(
        `/v1/crm/trades/${context.tradeId}/tasks`,
        values
      );

      context.insertTask(data);
      resetForm(initialValues);
    } catch {
      alert("Não conseguimos criar essa nova tarefa. Favor, tente mais tarde!");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, dirty, isValid, errors }) => (
        <div className="p-30">
          <Form>
            <div className="crm-trade-basic-title mb-15">NOVA TAREFA</div>

            <div className="pb-10">
              <Field
                label="Título"
                name="title"
                as={TextField}
                error={!!errors.title}
                helperText={errors.title}
                variant="outlined"
                fullWidth
              />
            </div>

            <div className="pb-10">
              <Field
                variant="outlined"
                label="Descrição (opcional)"
                name="description"
                as={TextField}
                rows={6}
                fullWidth
                multiline
              />
            </div>

            <div className="pb-10" style={{ display: "flex" }}>
              <div className="mr-5" style={{ width: "calc(50% - 5px)" }}>
                <Field
                  label="Inicia em"
                  name="start_date"
                  component={DateTimeField}
                  minDate={currentDate}
                  error={!!errors.start_date}
                  helperText={errors.start_date}
                  fullWidth
                />
              </div>

              <div className="ml-5" style={{ width: "calc(50% - 5px)" }}>
                <Field
                  label="Prazo limite"
                  name="due_date"
                  component={DateTimeField}
                  minDate={currentDate}
                  error={!!errors.due_date}
                  helperText={errors.due_date}
                  fullWidth
                />
              </div>
            </div>

            <Button
              type="submit"
              variant="outlined"
              style={{ height: "52px", borderRadius: "100px" }}
              disabled={isSubmitting || !dirty || !isValid}
              endIcon={isSubmitting && <CircularProgress size={14} />}
              fullWidth
            >
              Criar tarefa
            </Button>
          </Form>
        </div>
      )}
    </Formik>
  );
};
